import axios from "axios";
import {
	setupCache,
	buildMemoryStorage,
	defaultKeyGenerator,
} from "axios-cache-interceptor";
import { attachAuthInterceptor } from "../utils/sessionAuth";

export default class HttpClient {
	constructor(path, time = 5000) {
		const client = axios.create({
			baseURL: process.env.REACT_APP_API_URL + path,
			headers: {
				"Content-Type":
					"application/json, application/x-www-form-urlencoded",
				Accept: "application/json",
			},
		});

		attachAuthInterceptor(client);

		this.http = setupCache(client, {
			ttl: time,
			storage: buildMemoryStorage(),
			generateKey: defaultKeyGenerator,
			// headerInterpreter: defaultHeaderInterpreter,
			headerInterpreter: () => {
				return "not enough headers";
			},
			interpretHeader: false,
			debug: console.info,
		});
	}
}
